import { ReplayPlayer } from "./ReplayPlayer";

class ReplayAction {
  pseudo = "";
  eventType = "";
  step;
  potSize = 0;
  cards = [];
  players = [];

  static from(json) {
    let action = new ReplayAction();
    Object.assign(action, json);
    //players
    let _players = [];
    action.players.forEach((player) => {
      _players.push(ReplayPlayer.from(player));
    });
    action.players = _players;
    //cards
    return action;
  }
}

export default ReplayAction;
